import React from 'react';

class HomePage extends React.Component {
  
  render() {
    let contents = '';
    
    if (this.props.language === "EN") {
      contents = <div>
        <div className="splash">
          <div className="splash-text">
            <h1>Menetto World</h1>
            <h2>Sales and Services</h2>
            <p>Menetto Inc. is dedicated to selling used, refurbished, and new medical imaging equipment including nuclear medicine, ultrasound, X-Ray, mammography, and accessories. We offer systems, parts and services.</p>
            <p>We are committed to providing a qualified and personalized service to every customer for every request.</p>
          </div>
        </div>
        <div className="specializing">
          <div>
            <div className="image-samples">
              <img className="" src="./img/img3.png" alt=""/>
              <img className="" src="./img/img5.jpg" alt=""/>
              <img className="" src="./img/img7.jpg" alt=""/>
            </div>
          </div>
          <div>
          <h3>Specializing in:</h3>
              <p>Diagnostic Imaging Equipment</p>
              <p>Medical Equipment</p>
              <p>Parts and System</p>
              <p>Used, Refurbished, and New</p>
          </div>
        </div>
      </div>
    } else {
      contents = <div>
        <div className="splash">
          <div className="splash-text">
            <h1>Menetto World</h1>
            <h2>Ventas y Servicios</h2>
            <p>Menetto Inc. dedicada a la venta de equipos usados, reacondicionados o nuevos de uso en medicina de imagen: medicina nuclear, ultrasonido, Tomografia computada, Rayos X y accesorios. Proveemos sistemas, partes y servicios.</p>
            <p>Para Menetto Inc. es un placer poder trabajar con clientes de habla hispana porque el conocimiento del lenguaje y la cultura hispana aumenta la calidad de nuestros servicios, comprendiendo sus necesidades y buscando las soluciones adecuadas.</p>
          </div>
        </div>
        <div className="specializing">
          <div>
            <div className="image-samples">
              <img className="" src="./img/img3.png" alt=""/>
              <img className="" src="./img/img5.jpg" alt=""/>
              <img className="" src="./img/img7.jpg" alt=""/>
            </div>
          </div>
          <div>
          <h3>Especializado en:</h3>
              <p>Equipos de diagnóstico de imagen</p>
              <p>Equipamento Médico</p>
              <p>Partes y Sistemas</p>
              <p>Usado, Reacondicionado y Nuevo</p>
          </div>
        </div>
      </div>
    }
    
    return (
      <div className="Homepage">
        {contents}
      </div>
    )
  }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/Homepage.js